import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const profileSettingsPageChangePasswordSectionK = {
  oldPassword: "profile_settings_page_change_password_section.oldPassword",
  changePassword: "profile_settings_page_change_password_section.changePassword",
  passwordChangedSuccessfully: "profile_settings_page_change_password_section.passwordChangedSuccessfully",
  confirmPassword: "profile_settings_page_change_password_section.confirmPassword",
  newPassword: "profile_settings_page_change_password_section.newPassword",
};

export const useProfileSettingsPageChangePasswordSectionT = () => {
  const { t, i18n } = useTranslation();
  
  return useMemo(
    () => ({
      oldPassword: t(profileSettingsPageChangePasswordSectionK.oldPassword),
      changePassword: t(profileSettingsPageChangePasswordSectionK.changePassword),
      passwordChangedSuccessfully: t(profileSettingsPageChangePasswordSectionK.passwordChangedSuccessfully),
      confirmPassword: t(profileSettingsPageChangePasswordSectionK.confirmPassword),
      newPassword: t(profileSettingsPageChangePasswordSectionK.newPassword),
    }),
    [i18n.language]
  );
};